module.exports = __webpack_public_path__ + "static/img/data-index-bg.f7acebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dataCenter/data-index-bg.png
// module id = I0AE
// module chunks = 94